import React from 'react'
import cookie from 'js-cookie'
import { useConnect } from 'sb-redux-hook'
import { snowplow, constants, links } from 'common/helpers'
import { useState, useEffect, useCallback } from 'sb-hooks'
import useGlobals from 'sb-hooks/useGlobals'

import Box from 'components/_new/layout/Box/Box'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'

import messages from './messages'
import s from './AppStoreBanner.scss'

import logoImage from './images/logo.svg'


const AppStoreBanner = () => {
  const { page } = useConnect({ page: 'routing.location.pathname' })

  const isAppStoreBannerEnabled = useGlobals(({ globals, getCookieValue, getFeatureToggle }) => (
    getCookieValue(constants.cookieNames.banners.appStoreBanner) !== 'hidden'
    && getFeatureToggle(constants.features.appStoreBannerSite)
    && Object.values(links.subscription).includes(page)
    && globals.device.isMobile
  ), [ page ])

  const [ isHidden, setHidden ] = useState(false)

  const closeBanner = useCallback(() => {
    cookie.set(constants.cookieNames.banners.appStoreBanner, 'hidden')
    setHidden(true)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = useCallback(() => {
    snowplow.track(constants.snowplowEvents.appStore.bannerClick, { page })
    closeBanner()

    window.location = 'https://app.adjust.com/kze335m?campaign=popup-banner-site'
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isAppStoreBannerEnabled && !isHidden) {
      snowplow.track(constants.snowplowEvents.appStore.banner, { page })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (isHidden || !isAppStoreBannerEnabled) {
    return null
  }

  return (
    <Box className={s.container} pt="8" pb="8" pr="12" pl="12">
      <CloseIcon className={s.closeIcon} onClick={closeBanner} />
      <img src={logoImage} alt="" />
      <div className={s.content}>
        <Text message={messages.title} size="16-20" bold />
        <Text className={s.subTitle} message={messages.subTitle} size="14-16" />
      </div>
      <Button
        title={messages.buttonTitle}
        weight="medium"
        color="brand"
        size="sm"
        uppercase
        onClick={handleClick}
      />
    </Box>
  )
}


export default AppStoreBanner
